(() => {
  const SELECTOR = '[data-aw-product-compare-entry][data-aw-compare-source="pdp"]';

  const syncLink = (link) => {
    if (!link || link.dataset.awVariantCompareReady === 'true') return;
    const root = link.closest('[data-product-root]') || document;
    const variantSelect = root.querySelector('[data-variant-select]');

    const sync = () => {
      if (!variantSelect?.value) return;
      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('compare_variant', variantSelect.value);
        link.href = `${url.pathname}${url.search}${url.hash}`;
      } catch (_) {}
    };

    sync();
    variantSelect?.addEventListener('change', sync);
    link.dataset.awVariantCompareReady = 'true';
  };

  const init = (scope = document) => scope.querySelectorAll?.(SELECTOR).forEach(syncLink);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
